// // // import React from 'react';
// // // import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave } from 'react-icons/fa';
// // // import { MdOutlineBeachAccess } from 'react-icons/md';
// // // import { Link } from 'react-router-dom';

// // // const Navbar = ({ activeSection }) => {
// // //   const navItems = [
// // //     { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
// // //     { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
// // //     { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
// // //     { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
// // //     { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
// // //   ];

// // //   const linkClass = (id) => 
// // //     `flex items-center px-5 py-4 transition-all duration-300 text-lg ${
// // //       activeSection === id 
// // //         ? 'text-yellow-600 font-semibold' 
// // //         : 'text-gray-700 hover:text-yellow-500'
// // //     }`;

// // //   return (
// // //     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
// // //       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20">
// // //         {/* Logo - zaktualizowane z obrazkiem */}
// // //         <div className="flex items-center">
// // //           <a href="#hero" className="flex items-center">
// // //             <img 
// // //               src="images/LOGO.jpg" 
// // //               alt="Kolorowe Domki" 
// // //               className="h-20 w-auto mr-3" // Zwiększono wysokość z h-16 na h-20
// // //             />
// // //           </a>
// // //         </div>

// // //         {/* Nawigacja główna */}
// // //         <ul className="flex space-x-2">
// // //           {navItems.map(({ id, label, icon }) => (
// // //             <li key={id} className="group relative">
// // //               <a 
// // //                 href={`#${id}`}
// // //                 className={linkClass(id)}
// // //               >
// // //                 <span className="flex items-center gap-2">
// // //                   {icon}
// // //                   <span className="hidden sm:inline-block">{label}</span>
// // //                 </span>
// // //                 <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
// // //                   activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
// // //                 }`}></div>
// // //               </a>
// // //             </li>
// // //           ))}
// // //           {/* Specjalny link do cennika */}
// // //           <li className="group relative">
// // //             <Link
// // //               to="/cennik"
// // //               className="flex items-center px-5 py-4 transition-all duration-300 text-lg text-gray-700 hover:text-yellow-500"
// // //             >
// // //               <span className="flex items-center gap-2">
// // //                 <FaMoneyBillWave className="text-xl" />
// // //                 <span className="hidden sm:inline-block">Cennik</span>
// // //               </span>
// // //               <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 opacity-0 group-hover:opacity-50 transition-all duration-300"></div>
// // //             </Link>
// // //           </li>
// // //         </ul>

// // //         {/* Przycisk rezerwacji */}
// // //         <div className="hidden md:block ml-6">
// // //           <a 
// // //             href="#contact"
// // //             className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
// // //           >
// // //             Rezerwuj
// // //           </a>
// // //         </div>
// // //       </nav>
// // //     </header>
// // //   );
// // // };

// // // export default Navbar;

// // import React from 'react';
// // import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave } from 'react-icons/fa';
// // import { MdOutlineBeachAccess } from 'react-icons/md';
// // import { Link, useLocation } from 'react-router-dom';

// // const Navbar = ({ activeSection }) => {
// //   const location = useLocation();
// //   const isHomePage = location.pathname === '/';

// //   const navItems = [
// //     { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
// //     { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
// //     { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
// //     { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
// //     { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
// //   ];

// //   const handleSectionClick = (id, e) => {
// //     if (isHomePage) {
// //       e.preventDefault();
// //       const element = document.getElementById(id);
// //       if (element) {
// //         element.scrollIntoView({ behavior: 'smooth' });
// //       }
// //     }
// //   };

// //   const linkClass = (id) => 
// //     `flex items-center px-5 py-4 transition-all duration-300 text-lg ${
// //       activeSection === id 
// //         ? 'text-yellow-600 font-semibold' 
// //         : 'text-gray-700 hover:text-yellow-500'
// //     }`;

// //   return (
// //     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
// //       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20">
// //         {/* Logo */}
// //         <div className="flex items-center">
// //           {isHomePage ? (
// //             <a href="#hero" className="flex items-center">
// //               <img 
// //                 src="images/LOGOModern.jpg" 
// //                 alt="Kolorowe Domki" 
// //                 className="h-20 w-auto mr-3"
// //               />
// //             </a>
// //           ) : (
// //             <Link to="/" className="flex items-center">
// //               <img 
// //                 src="images/LOGOModern.jpg" 
// //                 alt="Kolorowe Domki" 
// //                 className="h-20 w-auto mr-3"
// //               />
// //             </Link>
// //           )}
// //         </div>

// //         {/* Nawigacja główna */}
// //         <ul className="flex space-x-2">
// //           {navItems.map(({ id, label, icon }) => (
// //             <li key={id} className="group relative">
// //               {isHomePage ? (
// //                 <a 
// //                   href={`#${id}`}
// //                   className={linkClass(id)}
// //                   onClick={(e) => handleSectionClick(id, e)}
// //                 >
// //                   <span className="flex items-center gap-2">
// //                     {icon}
// //                     <span className="hidden sm:inline-block">{label}</span>
// //                   </span>
// //                   <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
// //                     activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
// //                   }`}></div>
// //                 </a>
// //               ) : (
// //                 <Link
// //                   to={`/#${id}`}
// //                   className={linkClass(id)}
// //                 >
// //                   <span className="flex items-center gap-2">
// //                     {icon}
// //                     <span className="hidden sm:inline-block">{label}</span>
// //                   </span>
// //                   <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 opacity-0 group-hover:opacity-50 transition-all duration-300"></div>
// //                 </Link>
// //               )}
// //             </li>
// //           ))}
          
// //           {/* Specjalny link do cennika */}
// //           <li className="group relative">
// //             <Link
// //               to="/cennik"
// //               className="flex items-center px-5 py-4 transition-all duration-300 text-lg text-gray-700 hover:text-yellow-500"
// //             >
// //               <span className="flex items-center gap-2">
// //                 <FaMoneyBillWave className="text-xl" />
// //                 <span className="hidden sm:inline-block">Cennik</span>
// //               </span>
// //               <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 opacity-0 group-hover:opacity-50 transition-all duration-300"></div>
// //             </Link>
// //           </li>
// //         </ul>

// //         {/* Przycisk rezerwacji */}
// //         <div className="hidden md:block ml-6">
// //           {isHomePage ? (
// //             <a 
// //               href="#contact"
// //               className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
// //             >
// //               Rezerwuj
// //             </a>
// //           ) : (
// //             <Link
// //               to="/#contact"
// //               className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
// //             >
// //               Rezerwuj
// //             </Link>
// //           )}
// //         </div>
// //       </nav>
// //     </header>
// //   );
// // };

// // export default Navbar;


// import React from 'react';
// import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave } from 'react-icons/fa';
// import { MdOutlineBeachAccess } from 'react-icons/md';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = ({ activeSection }) => {
//   const location = useLocation();
//   const isHomePage = location.pathname === '/';

//   const navItems = [
//     { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
//     { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
//     { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
//     { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
//     { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
//   ];

//   const handleSectionClick = (id, e) => {
//     if (isHomePage) {
//       e.preventDefault();
//       const element = document.getElementById(id);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     }
//   };

//   const linkClass = (id) => 
//     `flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//       activeSection === id 
//         ? 'text-yellow-600 font-semibold' 
//         : 'text-gray-700 hover:text-yellow-500'
//     }`;

//   return (
//     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
//       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20">
//         {/* Logo */}
//         <div className="flex items-center">
//           {isHomePage ? (
//             <a href="#hero" className="flex items-center">
//               <img 
//                 src="images/LOGOModern.jpg" 
//                 alt="Kolorowe Domki" 
//                 className="h-20 w-auto mr-3"
//               />
//             </a>
//           ) : (
//             <Link to="/" className="flex items-center">
//               <img 
//                 src="images/LOGO.jpg" 
//                 alt="Kolorowe Domki" 
//                 className="h-20 w-auto mr-3"
//               />
//             </Link>
//           )}
//         </div>

//         {/* Nawigacja główna */}
//         <ul className="flex space-x-2">
//           {navItems.map(({ id, label, icon }) => (
//             <li key={id} className="group relative">
//               {isHomePage ? (
//                 <a 
//                   href={`#${id}`}
//                   className={linkClass(id)}
//                   onClick={(e) => handleSectionClick(id, e)}
//                 >
//                   <span className="flex items-center gap-2">
//                     {icon}
//                     <span className="hidden sm:inline-block">{label}</span>
//                   </span>
//                   <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
//                     activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
//                   }`}></div>
//                 </a>
//               ) : (
//                 <Link
//                   to={`/#${id}`}
//                   className={linkClass(id)}
//                 >
//                   <span className="flex items-center gap-2">
//                     {icon}
//                     <span className="hidden sm:inline-block">{label}</span>
//                   </span>
//                   <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 opacity-0 group-hover:opacity-50 transition-all duration-300"></div>
//                 </Link>
//               )}
//             </li>
//           ))}
          
//           {/* Specjalny link do cennika - POPRAWIONY */}
//           <li className="group relative">
//             <Link
//               to="/cennik"
//               className={`flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//                 location.pathname === '/cennik' 
//                   ? 'text-yellow-600 font-semibold' 
//                   : 'text-gray-700 hover:text-yellow-500'
//               }`}
//             >
//               <span className="flex items-center gap-2">
//                 <FaMoneyBillWave className="text-xl" />
//                 <span className="hidden sm:inline-block">Cennik</span>
//               </span>
//               <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
//                 location.pathname === '/cennik' ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
//               }`}></div>
//             </Link>
//           </li>
//         </ul>

//         {/* Przycisk rezerwacji */}
//         <div className="hidden md:block ml-6">
//           {isHomePage ? (
//             <a 
//               href="#contact"
//               className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
//             >
//               Rezerwuj
//             </a>
//           ) : (
//             <Link
//               to="/#contact"
//               className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
//             >
//               Rezerwuj
//             </Link>
//           )}
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Navbar;

// import React from 'react';
// import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave } from 'react-icons/fa';
// import { MdOutlineBeachAccess } from 'react-icons/md';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// const Navbar = ({ activeSection }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const isHomePage = location.pathname === '/';

//   const navItems = [
//     { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
//     { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
//     { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
//     { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
//     { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
//   ];

//   const handleSectionClick = (id, e) => {
//     if (isHomePage) {
//       e.preventDefault();
//       const element = document.getElementById(id);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     } else {
//       // Jeśli jesteśmy na innej stronie, najpierw wróć do strony głównej
//       e.preventDefault();
//       navigate('/', { state: { scrollTo: id } });
//     }
//   };

//   const handleReservationClick = (e) => {
//     if (isHomePage) {
//       e.preventDefault();
//       const element = document.getElementById('contact');
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     } else {
//       // Jeśli jesteśmy na innej stronie, najpierw wróć do strony głównej
//       e.preventDefault();
//       navigate('/', { state: { scrollTo: 'contact' } });
//     }
//   };

//   const linkClass = (id) => 
//     `flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//       activeSection === id 
//         ? 'text-yellow-600 font-semibold' 
//         : 'text-gray-700 hover:text-yellow-500'
//     }`;

//   return (
//     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
//       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20">
//         {/* Logo */}
//         <div className="flex items-center">
//           {isHomePage ? (
//             <a href="#hero" className="flex items-center" onClick={(e) => handleSectionClick('hero', e)}>
//               <img 
//                 src="images/LOGOModern.jpg" 
//                 alt="Kolorowe Domki" 
//                 className="h-20 w-auto mr-3"
//               />
//             </a>
//           ) : (
//             <Link to="/" className="flex items-center">
//               <img 
//                 src="images/LOGO.jpg" 
//                 alt="Kolorowe Domki" 
//                 className="h-20 w-auto mr-3"
//               />
//             </Link>
//           )}
//         </div>

//         {/* Nawigacja główna */}
//         <ul className="flex space-x-2">
//           {navItems.map(({ id, label, icon }) => (
//             <li key={id} className="group relative">
//               <a 
//                 href={`#${id}`}
//                 className={linkClass(id)}
//                 onClick={(e) => handleSectionClick(id, e)}
//               >
//                 <span className="flex items-center gap-2">
//                   {icon}
//                   <span className="hidden sm:inline-block">{label}</span>
//                 </span>
//                 <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
//                   activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
//                 }`}></div>
//               </a>
//             </li>
//           ))}
          
//           {/* Specjalny link do cennika - POPRAWIONY */}
//           <li className="group relative">
//             <Link
//               to="/cennik"
//               className={`flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//                 location.pathname === '/cennik' 
//                   ? 'text-yellow-600 font-semibold' 
//                   : 'text-gray-700 hover:text-yellow-500'
//               }`}
//             >
//               <span className="flex items-center gap-2">
//                 <FaMoneyBillWave className="text-xl" />
//                 <span className="hidden sm:inline-block">Cennik</span>
//               </span>
//               <div className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
//                 location.pathname === '/cennik' ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
//               }`}></div>
//             </Link>
//           </li>
//         </ul>

//         {/* Przycisk rezerwacji */}
//         <div className="hidden md:block ml-6">
//           <a 
//             href="#contact"
//             className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
//             onClick={handleReservationClick}
//           >
//             Rezerwuj
//           </a>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Navbar;



// 04012025
// import React, { useState } from 'react';
// import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave, FaBars, FaTimes } from 'react-icons/fa';
// import { MdOutlineBeachAccess } from 'react-icons/md';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// const Navbar = ({ activeSection }) => {
//   const [isOpen, setIsOpen] = useState(false); // Stan otwartego menu mobilnego
//   const location = useLocation();
//   const navigate = useNavigate();
//   const isHomePage = location.pathname === '/';

//   const navItems = [
//     { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
//     { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
//     { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
//     { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
//     { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
//   ];

//   const handleSectionClick = (id, e) => {
//     if (isHomePage) {
//       e.preventDefault();
//       const element = document.getElementById(id);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     } else {
//       e.preventDefault();
//       navigate('/', { state: { scrollTo: id } });
//     }
//     setIsOpen(false); // zamknij menu po kliknięciu
//   };

//   const handleReservationClick = (e) => {
//     if (isHomePage) {
//       e.preventDefault();
//       const element = document.getElementById('contact');
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     } else {
//       e.preventDefault();
//       navigate('/', { state: { scrollTo: 'contact' } });
//     }
//     setIsOpen(false);
//   };

//   const linkClass = (id) =>
//     `flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//       activeSection === id
//         ? 'text-yellow-600 font-semibold'
//         : 'text-gray-700 hover:text-yellow-500'
//     }`;

//   return (
//     <header className="sticky top-0 z-50 bg-white shadow-md">
//       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20 relative">
//         {/* Logo */}
//         <div className="flex items-center">
//           {isHomePage ? (
//             <a href="#hero" className="flex items-center" onClick={(e) => handleSectionClick('hero', e)}>
//               <img src="images/LOGOModern.jpg" alt="Kolorowe Domki" className="h-20 w-auto mr-3" />
//             </a>
//           ) : (
//             <Link to="/" className="flex items-center">
//               <img src="images/LOGOModern.jpg" alt="Kolorowe Domki" className="h-20 w-auto mr-3" />
//             </Link>
//           )}
//         </div>

//         {/* Hamburger button - widoczny tylko na mobilkach */}
//         <div className="md:hidden">
//           <button
//             onClick={() => setIsOpen(!isOpen)}
//             className="text-gray-700 hover:text-yellow-500 focus:outline-none"
//           >
//             {isOpen ? <FaTimes className="text-2xl" /> : <FaBars className="text-2xl" />}
//           </button>
//         </div>

//         {/* Nawigacja dla desktopu */}
//         <ul className="hidden md:flex space-x-2">
//           {navItems.map(({ id, label, icon }) => (
//             <li key={id} className="group relative">
//               <a href={`#${id}`} className={linkClass(id)} onClick={(e) => handleSectionClick(id, e)}>
//                 <span className="flex items-center gap-2">
//                   {icon}
//                   <span className="hidden sm:inline-block">{label}</span>
//                 </span>
//                 <div
//                   className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
//                     activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
//                   }`}
//                 ></div>
//               </a>
//             </li>
//           ))}
//           <li className="group relative">
//             <Link
//               to="/cennik"
//               className={`flex items-center px-5 py-4 transition-all duration-300 text-lg ${
//                 location.pathname === '/cennik' ? 'text-yellow-600 font-semibold' : 'text-gray-700 hover:text-yellow-500'
//               }`}
//             >
//               <span className="flex items-center gap-2">
//                 <FaMoneyBillWave className="text-xl" />
//                 <span className="hidden sm:inline-block">Cennik</span>
//               </span>
//             </Link>
//           </li>
//         </ul>

//         {/* Przycisk rezerwacji */}
//         <div className="hidden md:block ml-6">
//           <a
//             href="#contact"
//             className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg"
//             onClick={handleReservationClick}
//           >
//             Rezerwuj
//           </a>
//         </div>

//         {/* Menu mobilne */}
//         {isOpen && (
//           <ul className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col md:hidden z-40">
//             {navItems.map(({ id, label, icon }) => (
//               <li key={id} className="border-b border-gray-200">
//                 <a href={`#${id}`} className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={(e) => handleSectionClick(id, e)}>
//                   {icon}
//                   <span className="ml-3">{label}</span>
//                 </a>
//               </li>
//             ))}
//             <li className="border-b border-gray-200">
//               <Link to="/cennik" className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={() => setIsOpen(false)}>
//                 <FaMoneyBillWave className="text-xl" />
//                 <span className="ml-3">Cennik</span>
//               </Link>
//             </li>
//             <li className="border-b border-gray-200">
//               <a href="#contact" className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={handleReservationClick}>
//                 Rezerwuj
//               </a>
//             </li>
//           </ul>
//         )}
//       </nav>
//     </header>
//   );
// };

// export default Navbar;

import React, { useState } from 'react';
import { FaHome, FaInfoCircle, FaTags, FaEnvelope, FaMoneyBillWave, FaBars, FaTimes, FaFacebook, FaMapMarkerAlt } from 'react-icons/fa';
import { MdOutlineBeachAccess } from 'react-icons/md';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = ({ activeSection }) => {
  const [isOpen, setIsOpen] = useState(false); // Stan otwartego menu mobilnego
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const navItems = [
    { id: 'hero', label: 'Start', icon: <FaHome className="text-xl" /> },
    { id: 'about', label: 'O nas', icon: <FaInfoCircle className="text-xl" /> },
    { id: 'offer', label: 'Oferta', icon: <FaTags className="text-xl" /> },
    { id: 'attractions', label: 'Atrakcje', icon: <MdOutlineBeachAccess className="text-2xl" /> },
    { id: 'contact', label: 'Kontakt', icon: <FaEnvelope className="text-xl" /> },
  ];

  const locationLinks = [
    { 
      name: 'Kolorowe Domki', 
      url: 'https://www.google.com/maps/place/Kolorowe+Domki+Jastrz%C4%99bia+G%C3%B3ra/@54.8261562,18.3235798,18z/data=!4m6!3m5!1s0x46fc4b29b9b7bebb:0x5b107c7de8090dc!8m2!3d54.8267183!4d18.3243177!16s%2Fg%2F11kpzwbdzd?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D',
      shortName: 'Kolorowe Domki'
    },
    { 
      name: 'Apartamenty Kolorowe Domki', 
      url: 'https://www.google.com/maps/place/Apartamenty+Kolorowe+Domki/@54.8261729,18.3236189,19.08z/data=!4m6!3m5!1s0x46fc4b3498a3f99f:0xce86cb90a9dfbc7a!8m2!3d54.8259739!4d18.3237069!16s%2Fg%2F11fprzqp29?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D',
      shortName: 'Apartamenty Kolorowe Domki'
    }
  ];

  const handleSectionClick = (id, e) => {
    if (isHomePage) {
      e.preventDefault();
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      e.preventDefault();
      navigate('/', { state: { scrollTo: id } });
    }
    setIsOpen(false); // zamknij menu po kliknięciu
  };

  const handleReservationClick = (e) => {
    if (isHomePage) {
      e.preventDefault();
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      e.preventDefault();
      navigate('/', { state: { scrollTo: 'contact' } });
    }
    setIsOpen(false);
  };

  const linkClass = (id) =>
    `flex flex-col items-center justify-center px-4 py-4 transition-all duration-300 whitespace-nowrap h-16 ${
      activeSection === id
        ? 'text-yellow-600 font-semibold'
        : 'text-gray-700 hover:text-yellow-500'
    }`;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20 relative">
        {/* Lewa strona - Lokalizacje + Logo */}
        <div className="flex items-center">
          {/* Ikony lokalizacji - tylko na desktop - JEDNA POD DRUGĄ */}
          <div className="hidden md:flex flex-col space-y-2 mr-12">
            {locationLinks.map((locationItem, index) => (
              <a
                key={index}
                href={locationItem.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-700 hover:text-yellow-500 transition-colors duration-300 group"
                title={locationItem.name}
              >
                <FaMapMarkerAlt className="text-xl" />
                <span className="ml-2 text-sm whitespace-nowrap">{locationItem.shortName}</span>
              </a>
            ))}
          </div>

          {/* Logo */}
          <div className="flex items-center">
            {isHomePage ? (
              <a href="#hero" className="flex items-center" onClick={(e) => handleSectionClick('hero', e)}>
                <img src="images/LOGOModern.jpg" alt="Kolorowe Domki" className="h-20 w-auto" />
              </a>
            ) : (
              <Link to="/" className="flex items-center">
                <img src="images/LOGOModern.jpg" alt="Kolorowe Domki" className="h-20 w-auto" />
              </Link>
            )}
          </div>
        </div>

        {/* Hamburger button - widoczny tylko na mobilkach */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 hover:text-yellow-500 focus:outline-none"
          >
            {isOpen ? <FaTimes className="text-2xl" /> : <FaBars className="text-2xl" />}
          </button>
        </div>

        {/* Środkowa część - Nawigacja dla desktopu */}
        <ul className="hidden md:flex items-center space-x-1">
          {navItems.map(({ id, label, icon }) => (
            <li key={id} className="group relative">
              <a href={`#${id}`} className={linkClass(id)} onClick={(e) => handleSectionClick(id, e)}>
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex items-center justify-center flex-1">
                    {icon}
                  </div>
                  <span className="text-sm whitespace-nowrap mt-1">{label}</span>
                </div>
                <div
                  className={`absolute bottom-0 left-0 right-0 h-1 bg-yellow-500 transition-all duration-300 ${
                    activeSection === id ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'
                  }`}
                ></div>
              </a>
            </li>
          ))}
          <li className="group relative">
            <Link
              to="/cennik"
              className={`flex flex-col items-center justify-center px-4 py-4 transition-all duration-300 whitespace-nowrap h-16 ${
                location.pathname === '/cennik' ? 'text-yellow-600 font-semibold' : 'text-gray-700 hover:text-yellow-500'
              }`}
            >
              <div className="flex items-center justify-center flex-1">
                <FaMoneyBillWave className="text-xl" />
              </div>
              <span className="text-sm whitespace-nowrap mt-1">Cennik</span>
            </Link>
          </li>
        </ul>

        {/* Prawa strona - Facebook i przycisk rezerwacji */}
        <div className="hidden md:flex items-center space-x-6">
          {/* Ikona Facebook */}
          <a
            href="https://www.facebook.com/profile.php?id=61555866284892"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-blue-600 transition-colors duration-300"
            aria-label="Facebook Kolorowe Domki"
            title="Odwiedź nasz Facebook"
          >
            <FaFacebook className="text-2xl" />
          </a>

          {/* Przycisk rezerwacji */}
          <a
            href="#contact"
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
            onClick={handleReservationClick}
          >
            Rezerwuj
          </a>
        </div>

        {/* Menu mobilne */}
        {isOpen && (
          <ul className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col md:hidden z-40">
            {/* Lokalizacje w menu mobilnym */}
            <li className="border-b border-gray-200">
              <div className="px-6 py-4">
                <h3 className="text-gray-500 text-sm font-semibold mb-2">NASZE LOKALIZACJE</h3>
                {locationLinks.map((location, index) => (
                  <a
                    key={index}
                    href={location.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center py-2 text-gray-700 hover:text-yellow-500"
                  >
                    <FaMapMarkerAlt className="text-yellow-500 mr-3" />
                    <span>{location.name}</span>
                  </a>
                ))}
              </div>
            </li>

            {/* Linki nawigacyjne */}
            {navItems.map(({ id, label, icon }) => (
              <li key={id} className="border-b border-gray-200">
                <a href={`#${id}`} className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={(e) => handleSectionClick(id, e)}>
                  {icon}
                  <span className="ml-3 whitespace-nowrap">{label}</span>
                </a>
              </li>
            ))}
            
            {/* Cennik */}
            <li className="border-b border-gray-200">
              <Link to="/cennik" className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={() => setIsOpen(false)}>
                <FaMoneyBillWave className="text-xl" />
                <span className="ml-3">Cennik</span>
              </Link>
            </li>

            {/* Facebook w menu mobilnym */}
            <li className="border-b border-gray-200">
              <a
                href="https://www.facebook.com/profile.php?id=61555866284892"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-6 py-4 text-gray-700 hover:text-blue-600"
              >
                <FaFacebook className="text-xl" />
                <span className="ml-3">Facebook</span>
              </a>
            </li>

            {/* Przycisk rezerwacji */}
            <li className="border-b border-gray-200">
              <a href="#contact" className="flex items-center px-6 py-4 text-gray-700 hover:text-yellow-500" onClick={handleReservationClick}>
                <span className="font-semibold">Rezerwuj</span>
              </a>
            </li>
          </ul>
        )}
      </nav>
    </header>
  );
};

export default Navbar;